import { connect } from 'react-redux';
import Unavailability from '../components/unavailability';

const mapStateToProps = state => ({
  viewDimensions: state.gantt.viewDimensions,
  dateReference: state.gantt.dateReference,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Unavailability);
